import { Button } from 'semantic-ui-react';
import { useState } from 'react';

export const CloudinaryUploadWidget = ({ formik, fieldName, onSuccess, fullMenu, label }) => {
  const [widget, setWidget] = useState(null);
  const handleSuccess = response => {
    if (response.event === 'success') {
      const { width, height } = response.info;
      formik.setFieldValue(fieldName, response?.info?.url);
      const url = response?.info?.url.replace('http://res.cloudinary.com/culturemap-com/', '');
      if (onSuccess) onSuccess({ url, width, height });
    }
  };

  const initWidget = () => {
    const temp = window.cloudinary.createUploadWidget(
      {
        cloudName: 'culturemap-com',
        uploadPreset: 'preset1',
        apiKey: 396592871863735,
        sources: fullMenu ? ['local', 'url'] : ['local'],
        folder: 'photos',
        multiple: false,
        cropping: true,
        maxFileSize: 3 * 1024 * 1024,
      },
      (err, result) => handleSuccess(result)
    );

    setWidget(temp);
    temp.open();
  };

  const showWidget = () => initWidget();

  return (
    <Button
      type="button"
      size="tiny"
      labelPosition="left"
      content={label ? label : 'Upload'}
      icon="upload"
      onClick={() => showWidget(widget)}
    />
  );
};

export default CloudinaryUploadWidget;
